import { createContext, useContext } from 'react';
import { ICarePlan } from '../modules/unsw-fhir/CarePlan';

export interface ICarePlanContext {
  carePlan?: ICarePlan;
  setCarePlan: (carePlan?: ICarePlan) => Promise<void>;
  loading: boolean;
  error?: string;
}

export const initialCarePlanContext: ICarePlanContext = {
  carePlan: undefined,
  setCarePlan: async () => {},
  loading: false,
};

export const CarePlanContext = createContext<ICarePlanContext>(
  initialCarePlanContext,
);

export const useCarePlan = () => {
  const CarePlan = useContext(CarePlanContext);

  return CarePlan;
};
